/*
 * @Author: zhangguoliang
 * @Date: 2022-11-16 14:40:01
 * @LastEditors: zhangguoliang
 * @LastEditTime: 2022-11-16 14:40:10
 */
if (window.__MICRO_APP_ENVIRONMENT__) {
  // eslint-disable-next-line
  __webpack_public_path__ = window.__MICRO_APP_PUBLIC_PATH__
}
